import React from "react";
import { Field, withFormik } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormFooter from "forms/components/FormFooter";
import FormRow from "forms/components/FormRow";
import { RadioField, RenderField, RenderTypeahead } from "forms/fields";
import PropTypes from "prop-types";

import SubmitButton from "components/SubmitButton";
import { getFallbackLocale } from "utils/locale";
import Translate from "utils/translate";
import { isRequired } from "utils/validation";

import styles from "forms/forms.css";

const { t } = new Translate("SignUp");

const CompanyForm = ({ handleSubmit, setFieldValue }) => {
  const changeCountry = ({ id, translations }) =>
    setFieldValue("country", { id, name: translations[getFallbackLocale()] });

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <FormContainer>
        <FormRow>
          <Field
            component={RenderField}
            label={t("company.name")}
            name="name"
            validate={isRequired}
          />
          <Field
            component={RenderTypeahead}
            label={t("country")}
            name="country.name"
            onSelect={changeCountry}
            searchIndex="Country"
            searchKey={`translations.${getFallbackLocale()}`}
            validate={isRequired}
          />
        </FormRow>
        <FormRow columns={1}>
          <p>{t("company.role")}</p>
        </FormRow>
        <FormRow columns={1}>
          <Field
            component={RadioField}
            label={t("company.roles.ownerLeasing")}
            name="role"
            type="radio"
            value="owner_leasing"
          />
        </FormRow>
        <FormRow columns={1}>
          <Field
            component={RadioField}
            label={t("company.roles.ownerFlex")}
            name="role"
            type="radio"
            value="owner_flex"
          />
        </FormRow>
        <FormRow columns={1}>
          <Field
            component={RadioField}
            label={t("company.roles.broker")}
            name="role"
            type="radio"
            validate={isRequired}
            value="broker_leasing"
          />
        </FormRow>
        <FormFooter>
          <SubmitButton submitLabel={t("getStarted")} submittingLabel={t("getStarted")} />
        </FormFooter>
      </FormContainer>
    </form>
  );
};

CompanyForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func,
};

export default withFormik({
  displayName: "signup",
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
})(CompanyForm);
